import http from 'hub-http/clients/apiClient';
import { getDemographicsPortalUrl } from './urls';
export function getPortalDemographics() {
  return http.get(getDemographicsPortalUrl());
}
export function setPortalDemographics(portalDemographics, urlTransform) {
  return http.post(getDemographicsPortalUrl(urlTransform), {
    data: portalDemographics
  });
}
export function updatePortalDemographics(portalDemographics) {
  return http.patch(getDemographicsPortalUrl(), {
    data: portalDemographics
  });
}